import React from "react";
import styled from "styled-components";
import {
  AppStoreCTA,
  FlexColumnContainer,
  GooglePlayCTA,
  SmartPhoneCheck,
  StrongText,
} from "@trailhead/core-ui";
import { Link } from "@trailhead/asurion-ui";
import { getDispatcher, trackEvent } from "@trailhead/analytics";
import { useSanitizedTranslation } from "@trailhead/i18n";
import { Text } from "@trailhead/asurion-ui";

const AppCTAWrapper = styled.div`
  width: 100%;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
`;

const AppCTAContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  background-color: #f0f0f5;
  align-self: left;
`;

const CallToAction = styled(FlexColumnContainer)`
  align-items: left;
  width: 100%;
  padding-right: 1rem;
`;

const CallToActionHeader = styled(Text)`
  max-width: 315px;
  display: inline-block;
`;

const CallToActionSubHeader = styled(Text)`
  text-align: left;
  max-width: 450px;
`;

const CallToActionList = styled.ul`
  list-style: inside;
  padding-left: 8px;
  margin-bottom: 20px
`;

const ImageWrapper = styled.div`
  text-align: left;
`;

const StoreCTAWrapper = styled.div`
  display: flex;
  cursor: pointer;
`;

const CTALink = styled(Link)`
  display: flex;
  text-decoration: none;
`;

const CallToActionItem = styled.li`
  padding-bottom: 8px;
  font-size: 1rem;
  line-height: 1.3;

  :last-child {
    padding-bottom: 0px;
  }
`;

const NoWrap = styled.span`
  white-space: nowrap;
`;

const trackButtonClick = (eventName: string) => {
  trackEvent(eventName);
};

export const AppCTAVersionA: React.FC = () => {
  function isIOS() {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes((getDispatcher().context.ExtraData.OsType) ?? "") ||
      // iPad on iOS 13 detection
      navigator.userAgent.includes("Mac")
    );
  }

  const t = useSanitizedTranslation();

  return (
    <AppCTAWrapper>
      <AppCTAContainer>
        <CallToAction>
          <StrongText>
            <CallToActionHeader size={3} weight={"heavy"}>
              {t("It’s easy to use your plan with the ")}
              <NoWrap>{t("Tech Coach app")}</NoWrap>
            </CallToActionHeader>
          </StrongText>
          <CallToActionSubHeader>
            <CallToActionList>
              <CallToActionItem>{t("Manage your plan benefits")}</CallToActionItem>
              <CallToActionItem>{t("Get 24/7 tech support")}</CallToActionItem>
              <CallToActionItem>{t("File or track existing claims")}</CallToActionItem>
            </CallToActionList>
          </CallToActionSubHeader>
          <StoreCTAWrapper>
            {isIOS() ? (
              <CTALink
                onClick={() => {
                  trackButtonClick("AppleCTALinkClick");
                }}
                href="https://apps.apple.com/us/app/tech-coach/id1065341814"
                target="_blank"
                rel="noopener noreferrer"
              >
                <AppStoreCTA />
              </CTALink>
            ) : (
              <CTALink
                href="https://play.google.com/store/apps/details?id=com.asurion.solutohome.verizon&hl=en_US&gl=US"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  trackButtonClick("AndroidCTALinkClick");
                }}
              >
                <GooglePlayCTA />
              </CTALink>
            )}
          </StoreCTAWrapper>
        </CallToAction>
        <ImageWrapper>
          <SmartPhoneCheck />
        </ImageWrapper>
      </AppCTAContainer>
    </AppCTAWrapper>
  );
};
